export default __webpack_public_path__ + "static/media/testimonial1.305cc4bc.png";